export const ALL_STEPS = [
  'appointment_scheduled',
  'qualified_to_buy',
  'presentation_scheduled',
  'contract_sent',
  'closed_won',
  'closed_lost',
];